<template>
  <transition enter-active-class="ease-out duration-300"
              enter-class="opacity-0"
              enter-to-class="opacity-100"
              leave-active-class="ease-in duration-200"
              leave-class="opacity-100"
              leave-to-class="opacity-0"
              @after-enter="showContent = true"
              @after-leave="closeModal"
  >
    <div v-if="show" class="fixed top-4 z-20 inset-x-0 px-4 pb-4 sm:mx-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
      <div class="fixed inset-0 transition-opacity" @click.prevent="closeModal">
        <div class="absolute inset-0 bg-black opacity-30" />
      </div>

      <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
      <transition enter-active-class="ease-out duration-300"
                  enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                  leave-active-class="ease-in duration-200"
                  leave-class="opacity-100 translate-y-0 sm:scale-100"
                  leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  @after-leave="closeModal"
      >
        <div v-if="showContent" class="relative bg-white rounded-lg px-4 pt-5 pb-4 overflow-x-hidden shadow-xl transform transition-all sm:w-full sm:p-6 max-h-full overflow-y-auto" :class="{'sm:max-w-lg': size === 'sm', 'sm:max-w-6xl max-h-full overflow-y-auto': size === 'lg', 'sm:max-w-7xl max-h-full overflow-y-auto': size === 'xl', 'sm:max-w-2xl': size === 'md'}" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
            <button type="button" class="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150" aria-label="Close" @click="closeModal">
              <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div class="text-left">
            <slot />
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      default: 'sm'
    }
  },

  data() {
    return {
      showContent: false,
    }
  },

  methods: {
    closeModal() {
      this.$emit('closeModal')
      this.showContent = false
    }
  }
}
</script>

<style scoped>

</style>
